export default "__VITE_ASSET__c7169827__"